import { action, computed, observable } from 'mobx';

export enum ApiState {
  IDLE,
  LOADING,
  SUCCESS,
  ERROR,
  CLIENT_ERROR,
}

export abstract class ApiStore {
  @computed
  get hasFailed() {
    return this.apiState === ApiState.ERROR || this.apiState === ApiState.CLIENT_ERROR;
  }
  @computed
  get hasLoaded() {
    return this.apiState === ApiState.SUCCESS;
  }
  @computed
  get hasClientError() {
    return this.apiState === ApiState.CLIENT_ERROR;
  }

  @computed
  get isDone() {
    return [ApiState.SUCCESS, ApiState.ERROR, ApiState.CLIENT_ERROR].includes(this.apiState);
  }
  @computed
  get isLoading() {
    return this.apiState === ApiState.LOADING;
  }
  @observable apiState: ApiState = ApiState.IDLE;
  @observable lastLoadError: Error | null = null;
  @action
  setClientErrorApiState = (e: unknown) => {
    this.apiState = ApiState.CLIENT_ERROR;
    this.lastLoadError = e as Error;
  };
  @action
  setErrorApiState = (e: unknown) => {
    this.apiState = ApiState.ERROR;
    this.lastLoadError = e as Error;
  };
  @action
  setLoadingApiState = () => {
    this.apiState = ApiState.LOADING;
  };
  @action
  setSuccessApiState = () => {
    this.apiState = ApiState.SUCCESS;
  };
}
